import { render, staticRenderFns } from "./_DoInsurance.vue?vue&type=template&id=572b18c8&scoped=true"
import script from "./_DoInsurance.vue?vue&type=script&lang=js"
export * from "./_DoInsurance.vue?vue&type=script&lang=js"
import style0 from "./_DoInsurance.vue?vue&type=style&index=0&id=572b18c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b18c8",
  null
  
)

export default component.exports